var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mx-2",attrs:{"fab":"","dark":"","small":"","color":"primary","loading":_vm.sendingFavorite == _vm.recipe.id},on:{"click":function($event){$event.stopPropagation();return _vm.setFavorite()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(_vm.recipe.isFavorite ? "mdi-heart" : "favorite_border"))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }